import { Work } from '@pages/models/work.interface';

export const works: Work[] = [
  {
    src: 'assets/images/roadmap-cp.png',
    title: 'Roadmap CP',
    description: 'works.description13',
    date: '2022/08',
  },
  {
    src: 'assets/images/roadmap.png',
    title: 'Roadmap',
    description: 'works.description12',
    isPublished: true,
    link: 'https://roadmap-platform.web.app',
    date: '2022/08',
  },
  {
    src: 'assets/images/mts.svg',
    title: 'MTS',
    description: 'works.description11',
    isPublished: true,
    link: 'https://mytrendingstories.com',
    date: '2022',
  },
  {
    src: 'assets/images/govd.svg',
    title: 'Government of Dubai',
    description: 'works.description10',
    isPublished: true,
    link: 'https://www.dm.gov.ae',
    date: '2022/04',
  },
  {
    src: 'assets/images/mof.png',
    title: 'UAE Ministry of Finance',
    description: 'works.description9',
    isPublished: true,
    link: 'https://www.mof.gov.ae/en/Pages/default.aspx',
    date: '2022/03',
  },
  {
    src: 'assets/images/hevolution.png',
    title: 'Hevolution',
    description: 'works.description8',
    isPublished: true,
    link: 'https://hevolutionfoundation.com',
    date: '2022/02',
  },
  {
    src: 'assets/images/na.png',
    title: 'UAE National Archives',
    description: 'works.description7',
    isPublished: true,
    link: 'https://www.na.ae/en',
    date: '2022/01',
  },
  {
    src: 'assets/images/adx.png',
    title: 'ADX',
    description: 'works.description6',
    isPublished: true,
    link: 'https://www.adx.ae/English/Pages/default.aspx',
    date: '2021/12',
  },
  {
    src: 'assets/images/portfolio.svg',
    title: 'Portfolio',
    description: 'works.description5',
    date: '2021/10',
  },
  {
    src: 'assets/images/enhance.png',
    title: 'Enhance',
    description: 'works.description4',
    isPublished: true,
    link: 'https://enhance-platform.web.app',
    date: '2021/06',
  },
  {
    src: 'assets/images/scholar.svg',
    title: 'Scholar Live',
    description: 'works.description3',
    date: '2020/07',
  },
  {
    src: 'assets/images/resto.svg',
    title: 'Resto',
    description: 'works.description2',
    date: '2019/11',
  },
  {
    src: 'assets/images/cfi.svg',
    title: 'CFI',
    description: 'works.description1',
    isPublished: true,
    link: 'https://cfi-tr.web.app',
    date: '2017/11',
  },
];
